import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'
// import config from '../../config'
import {GET_LANGUAGES, GET_ABOUT_CONTENT} from './actionTypes'
// import fetchData from '../../utils/fetch-data'

import config, {prefix} from '../../config'
// import {getCookie} from '../../utils/cookie'


// const homePage = (process.env.NODE_ENV === 'development') ?
//   true : window.theme.isHomePage
// const groupName = !homePage ? window.theme.cityAlias : false

const useLanguagesActions = () => {
  const dispatch = useDispatch()
  const getLanguages = useCallback(async () => {
    dispatch({
      type: GET_LANGUAGES,
      // payload: await fetchData(config.getAPI),
      payload: await axios.get(`${prefix}${config.getAPI}`),
    })
  }, [dispatch])

  return {getLanguages}
}

export default useLanguagesActions

export const useAboutContentActions = () => {
  const dispatch = useDispatch()
  const getContent = useCallback(async () => {
    dispatch({
      type: GET_ABOUT_CONTENT,
      payload: await axios.get(`${prefix}${config.getContent}`),
      // payload: `${prefix}${config.getContent}`,
    })
  }, [dispatch])

  return {getContent}
}
